import styled from "@emotion/styled";

import { tokens } from "@/shared/design-system/tokens";

export const SignatureContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${tokens.spacing.sm};
  width: 600px;
  max-width: 100%;
`;

export const Label = styled.span`
  color: ${tokens.colors.basics[0]};
  font-size: ${tokens.typography.fontSize.sm};
  font-weight: ${tokens.typography.fontWeight.semibold};
`;

export const CanvasContainer = styled.div<{ $disabled: boolean }>`
  position: relative;
  width: 100%;
  box-sizing: border-box;

  background:
    repeating-linear-gradient(
        90deg,
        ${tokens.colors.basics[700]} 0 6px,
        transparent 6px 11px
      )
      top / 100% 1px no-repeat,
    repeating-linear-gradient(
        90deg,
        ${tokens.colors.basics[700]} 0 6px,
        transparent 6px 11px
      )
      bottom / 100% 1px no-repeat,
    repeating-linear-gradient(
        180deg,
        ${tokens.colors.basics[700]} 0 6px,
        transparent 6px 11px
      )
      left / 1px 100% no-repeat,
    repeating-linear-gradient(
        180deg,
        ${tokens.colors.basics[700]} 0 6px,
        transparent 6px 11px
      )
      right / 1px 100% no-repeat;

  opacity: ${({ $disabled }) => ($disabled ? 0.6 : 1)};
`;

export const Canvas = styled.canvas<{ $disabled: boolean }>`
  display: block;
  width: 100%;
  height: 200px;
  cursor: ${({ $disabled }) => ($disabled ? "not-allowed" : "crosshair")};
  touch-action: none;
  filter: invert(1);
`;

export const ClearButton = styled.button`
  position: absolute;
  top: -14px;
  right: -14px;
  z-index: 1;

  display: grid;
  place-items: center;
  width: 28px;
  height: 28px;
  padding: 0;

  border: 0;
  border-radius: ${tokens.borderRadius.full};
  background: ${tokens.colors.basics[0]};
  cursor: pointer;

  &:disabled {
    cursor: not-allowed;
    opacity: 0.6;
  }

  &:focus-visible {
    outline: 2px solid ${tokens.colors.blue[900]};
    outline-offset: 2px;
  }
`;
